import jwtAxios from '@tenant/services/auth/jwt-auth';

export const CONTAINER_APP_APIS = {
  ROOT: 'api/app-instances/:appInstanceId/container-apps/:containerAppId',
};

const replaceEndpointUrl = (
  appInstanceId,
  containerAppId,
  endpoint = CONTAINER_APP_APIS.ROOT,
) => {
  return endpoint
    .replace(':appInstanceId', appInstanceId)
    .replace(':containerAppId', containerAppId);
};

export const getDetailContainerAppQuery = ({
  appInstanceId,
  containerAppId,
}) => {
  return jwtAxios.get(replaceEndpointUrl(appInstanceId, containerAppId));
};

export const startContainerApp = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.post(
    replaceEndpointUrl(appInstanceId, containerAppId) + ':start',
    payload,
  );
};

export const stopContainerApp = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.post(
    replaceEndpointUrl(appInstanceId, containerAppId) + ':stop',
    payload,
  );
};

export const getListLogContainerAppQuery = ({
  appInstanceId,
  containerAppId,
  keyword,
  logLevels,
  ...payload
}) => {
  const body = {
    appInstanceId,
    containerAppId,
    ...payload,
  };

  if (keyword && keyword.trim() !== '') {
    body.keyword = keyword.trim();
  }

  if (logLevels && logLevels.length > 0) {
    body.logLevels = logLevels;
  }

  return jwtAxios.post(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/logs',
    body,
  );
};

export const getListExecutionContainerAppQuery = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.get(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/job-excutions',
    {
      appInstanceId,
      containerAppId,
      ...payload,
    },
  );
};

export const updateEnvironmentVariablesAppQuery = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.put(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/enviroment-variables',
    payload,
  );
};

export const updateCronAppQuery = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.put(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/Cron',
    payload.Cron,
  );
};

export const updateResourceAllocationAppQuery = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.put(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/resources',
    payload,
  );
};

export const updateNetworkingConfigurationAppQuery = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.put(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/configure-network',
    payload,
  );
};

export const bindDomainManual = ({
  appInstanceId,
  containerAppId,
  ...payload
}) => {
  return jwtAxios.post(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/bind-domain',
    payload,
  );
};

export const unbindDomain = ({ appInstanceId, containerAppId }) => {
  return jwtAxios.post(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/unbind-domain',
  );
};

export const checkDomain = ({ subdomain }) => {
  return jwtAxios.get('/api/app-instances/check-subdomain/' + subdomain);
};

export const changeVersionContainer = ({
  appInstanceId,
  containerAppId,
  imageId,
}) => {
  return jwtAxios.put(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/image/' + imageId,
  );
};

export const fetchListImageVersions = ({ appInstanceId, containerAppId }) => {
  return jwtAxios.get(
    replaceEndpointUrl(appInstanceId, containerAppId) + '/images',
  );
};

export const deleteContainerAppAPI = ({ appInstanceId, containerAppId }) => {
  return jwtAxios.delete(replaceEndpointUrl(appInstanceId, containerAppId));
};
